const parseError = (err) => {
  if (err.isAxiosError && err.response?.data) {
    return err.response.data;
  } else {
    return err.message;
  }
};

export default parseError;
